import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Move = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 3.5C1.5 2.67157 2.17157 2 3 2H6.24528C6.76285 2 7.24386 2.26682 7.51785 2.70592L8.13053 3.68777C8.22186 3.83414 8.3822 3.92308 8.55472 3.92308H13C13.8284 3.92308 14.5 4.59465 14.5 5.42308V12.5C14.5 13.3284 13.8284 14 13 14H3C2.17157 14 1.5 13.3284 1.5 12.5V11.5C1.5 11.2239 1.72386 11 2 11C2.27614 11 2.5 11.2239 2.5 11.5V12.5C2.5 12.7761 2.72386 13 3 13H13C13.2761 13 13.5 12.7761 13.5 12.5V5.42308C13.5 5.14693 13.2761 4.92308 13 4.92308H8.55472C8.03715 4.92308 7.55614 4.65625 7.28215 4.21716L6.66947 3.23531C6.57814 3.08894 6.41781 3 6.24528 3H3C2.72386 3 2.5 3.22386 2.5 3.5V6.5C2.5 6.77614 2.27614 7 2 7C1.72386 7 1.5 6.77614 1.5 6.5V3.5ZM6.05636 11.4336C5.8611 11.2384 5.8611 10.9218 6.05636 10.7265L7.20183 9.58105H2.5C2.22386 9.58105 2 9.3572 2 9.08105C2 8.80491 2.22386 8.58105 2.5 8.58105H7.20378L6.05636 7.43363C5.8611 7.23837 5.8611 6.92179 6.05636 6.72652C6.25162 6.53126 6.5682 6.53126 6.76347 6.72652L8.76347 8.72652C8.95873 8.92179 8.95873 9.23837 8.76347 9.43363L6.76347 11.4336C6.5682 11.6289 6.25162 11.6289 6.05636 11.4336Z"
      />
    </svg>
  )
})

export default Move
